import {
  useQuery,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import axiosAuth from "../axiosAuth";
import { CLEARING_DOC_API } from "./apiRoutes";

interface UseGetClearingStatProps {
  communityId: string;
  year: string;
  queryParams?: Omit<UseQueryOptions, "queryKey">;
}

const getClearingStat = async (communityId: string, year: string) =>
  await axiosAuth.get(`${CLEARING_DOC_API(communityId)}/stats/${year}`);

const useGetClearingStat = ({
  communityId,
  year,
  queryParams,
}: UseGetClearingStatProps): UseQueryResult<any> => {
  return useQuery({
    queryKey: ["clearing-stat", communityId, year],
    queryFn: () => getClearingStat(communityId, year),
    select: (data: any) => data.data,
    refetchOnWindowFocus: false,
    ...queryParams,
  });
};

export default useGetClearingStat;
